import { Link } from "react-router";
import "./app-links.css";

export default function AppLinks() {
    return (
        <div id="app-link-page">
            <div id='app-link-wrapper' className="container">
                <h1>Team Applications</h1>

                <div id="grid-container">
                    <h2>Lab Use Only</h2>
                    <div id="lab-only">
                        <a href="https://docs.google.com/document/d/1tCZWvEjruZ2hO-ukc2Nbap6ef99bcGK-p5BrG1dh__E/edit?usp=sharing"
                            target="_blank" rel="noopener noreferrer" className="app-link" id="data-finder">Data Finder</a>
                        <a href="https://growthspurt.rll.byu.edu/" target="_blank" rel="noopener noreferrer" className="app-link" id="growth-spurt">Growth Spurt</a>
                    </div>
                    <h2>Public Use</h2>
                    <div id="public">
                        <a href="https://hintbutton.rll.byu.edu/" target="_blank" rel="noopener noreferrer" className="app-link" id="quick-hints">Quick Hints</a>
                        <a href="https://indexing.familytech.byu.edu/home" target="_blank" rel="noopener noreferrer" className="app-link" id="rev-indexing">Reverse Indexing</a>
                        <a href="https://fiveaday.rll.byu.edu/" target="_blank" rel="noopener noreferrer" className="app-link" id="five-day">5-a-Day</a>
                        <a href="https://ourbeginnings.rll.byu.edu/" target="_blank" rel="noopener noreferrer" className="app-link" id="beginnings">Our Beginnings</a>
                        <a href="https://mapapp.rll.byu.edu/" target="_blank" rel="noopener noreferrer" className="app-link" id="geo-hints">Geo Hints</a>
                        <a href="https://pypi.org/project/NameComparator/" target="_blank" rel="noopener noreferrer" className="app-link" id="name-comp">Name Comparator</a>
                    </div>


                </div>
                <Link to="/">
                    <div className="app-link" id="home-button">
                        Return to Home
                    </div>
                </Link>
            </div>
        </div>
    );
}